import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import { formatDateRange } from "../../../utils/statistics/statisticsUtils";

export default function useStatisticsQuery({ endpoint, token, dateRange, filters = {}, enabled = true }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    if (!token || !endpoint || !enabled) {
      return;
    }
    setLoading(true);
    try {
      const query = {
        ...formatDateRange(dateRange),
        ...filters,
      };
      const res = await endpoint.run({ token, query });
      if (res.result) {
        setData(res.data || null);
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [token, endpoint, dateRange, filters, enabled]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, data, refresh: fetchData };
}
